<template><TableInvMovements /></template>
<script>
import TableInvMovements from '../inventory/TableInvMovements.vue'
export default { name: 'ReportMovements', components: { TableInvMovements } }
</script>
